export const FacilityMap = {
  bar: 1,
  beachFront: 2,
  facilitiesRestaurant: 4,
  famillyRoom: 8,
  fitnessRoom: 16,
  forDisabled: 32,
  parkingFree: 64,
  parkingWithFee: 128,
  petsAllowed: 256,
  spaWellnessCentre: 512,
  swimmingPool: 1024,
  wifiFree: 2048,
}


export const facilities = [
  { facility: FacilityMap.bar, label: "Bar", icon: "bar" },
  { facility: FacilityMap.beachFront, label: "am Strand", icon: "beach" },
  { facility: FacilityMap.facilitiesRestaurant, label: "Restaurant", icon: "restaurant" },
  { facility: FacilityMap.famillyRoom, label: "Familienzimmer", icon: "family-room" },
  { facility: FacilityMap.fitnessRoom, label: "Fitnesscenter", icon: "fitness-room" },
  { facility: FacilityMap.forDisabled, label: "Behindertenfreundlich", icon: "for-disabled" },
  { facility: FacilityMap.parkingFree, label: "Parkplätze inbegriffen", icon: "parking-free" },
  { facility: FacilityMap.parkingWithFee, label: "Parkplatz", icon: "parking-with-fee" },
  { facility: FacilityMap.petsAllowed, label: "Haustiere erlaubt", icon: "pets-allowed" },
  { facility: FacilityMap.spaWellnessCentre, label: "Spa & Wellnesscenter", icon: "spa-wellness-centre" },
  { facility: FacilityMap.swimmingPool, label: "Pool", icon: "swimming-pool" },
  { facility: FacilityMap.wifiFree, label: "WLAN inklusive", icon: "wifi-free" },
]

